import ApplicationHeader from '@rio-cloud/rio-uikit/ApplicationHeader';
import { ReactNode } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { CustomFormattedMessage } from '../../i18n/i18n';
import { RioAppNavigatorDropdown } from './RioAppNavigatorDropdown';
import { UserMenu } from './UserMenu';
import { SupportMenu } from './SupportMenu';
import { appConfiguration } from '../../configuration/appConfiguration';
import {
  BOOKINGS_ROUTE,
  DASHBOARD_ROUTE,
  LANDING_ROUTE,
  ONBOARDING_ROUTE,
  OVERVIEW_ROUTE,
  TRANSACTIONS_ROUTE,
} from '../../routes/routes';

export const Header = () => {
  const { pathname } = useLocation();

  const navItems: { key: string; route: ReactNode }[] = [
    {
      key: 'overview',
      route: (
        <NavLink
          to={OVERVIEW_ROUTE}
          className={({ isActive }) =>
            isActive || pathname === LANDING_ROUTE ? 'active' : ''
          }
        >
          <CustomFormattedMessage id={'base.header.navigationLinks.overview'} />
        </NavLink>
      ),
    },
    {
      key: 'onboarding',
      route: (
        <NavLink to={ONBOARDING_ROUTE}>
          <CustomFormattedMessage
            id={'base.header.navigationLinks.onboarding'}
          />
        </NavLink>
      ),
    },
    {
      key: 'dashboard',
      route: (
        <NavLink to={DASHBOARD_ROUTE}>
          <CustomFormattedMessage
            id={'base.header.navigationLinks.dashboard'}
          />
        </NavLink>
      ),
    },
    {
      key: 'transactions',
      route: (
        <NavLink to={TRANSACTIONS_ROUTE}>
          <CustomFormattedMessage
            id={'base.header.navigationLinks.transactions'}
          />
        </NavLink>
      ),
    },
    {
      key: 'bookings',
      route: (
        <NavLink to={BOOKINGS_ROUTE}>
          <CustomFormattedMessage id={'base.header.navigationLinks.bookings'} />
        </NavLink>
      ),
    },
  ];

  return (
    <ApplicationHeader
      label={'MAN SimplePay'}
      appNavigator={<RioAppNavigatorDropdown />}
      homeRoute={
        <a
          href={appConfiguration.home.url}
          target="_top"
        />
      }
      navItems={navItems}
      actionBarItems={[
        <SupportMenu key="support-menu" />,
        <UserMenu key="user-menu" />,
      ]}
    />
  );
};
